import { MymachineItem, Discontinuation } from "./mymachine-response";
import { ProductionStatus } from "../production-status/production-status-enum";

const row =
    (softwareUpdatesAvailable: boolean) =>
    ({
        number,
        name,
        isFav,
        toggleFavUrl,
        constructionYear,
        subEquipments,
        location,
        serviceAgreement,
        detailLink,
        inProduction,
        discontinued,
        softwareUpdates,
    }: MymachineItem): any => {
        const renderSoftwareUpdatess = softwareUpdatesAvailable
            ? `
        <td>
            ${
                softwareUpdates &&
                "state" in softwareUpdates &&
                "label" in softwareUpdates
                    ? renderSoftwareStatusLabel(
                          softwareUpdates.state,
                          softwareUpdates.label
                      )
                    : ""
            }
        </td>
    `
            : "";

        return `
        <tr>
            <td>
                <ux-iws-async-toggle-button sync-id="${number}" ${isFav ? "on" : "off"} toggle-url="${toggleFavUrl}">
                    <ux-icon slot="on" name="bookmark" filled=""></ux-icon>
                    <ux-icon slot="off" name="bookmark"></ux-icon>
                </ux-iws-async-toggle-button>
            </td>
            <td>
            ${
                discontinued
                    ? renderDiscontinuationIcon(discontinued, number)
                    : ""
            }${name}
            </td>
            <td>${number}</td>
            <td>${
                !inProduction
                    ? constructionYear
                    : renderProductionStatusLabel(inProduction)
            }</td>
            <td>${subEquipments}</td>
            <td>${location}</td>
            ${renderSoftwareUpdatess}
            ${
                typeof serviceAgreement !== "undefined"
                    ? `<td>${serviceAgreement}</td>`
                    : ""
            }
            <td><ux-button size="icon" icon="chevron-right" href="${detailLink}"></ux-button></td>
        </tr>
    `;
    };

const renderProductionStatusLabel = (labelText: string) => {
    return `<ux-iws-production-status type=${ProductionStatus.IN_PRODUCTION}>${labelText}</ux-iws-production-status>`;
};

const renderDiscontinuationIcon = (
    discontinuationInfo: Discontinuation,
    tooltipIdentifier
): any => {
    return discontinuationInfo
        ? `<ux-iws-discontinuation-icon
            tooltip-identifier="${tooltipIdentifier}"
            type="${discontinuationInfo.type}"
            status="${discontinuationInfo.status}"
            extended-support="${discontinuationInfo.extendedSupport}"
            ></ux-iws-discontinuation-icon>
            <ux-iws-discontinuation-tooltip
                    tooltip-identifier="${tooltipIdentifier}"
                    type="${discontinuationInfo.type}"
                    status="${discontinuationInfo.status}"
                    extended-support="${discontinuationInfo.extendedSupport}"
                    head="${discontinuationInfo.head}"
                    text="${discontinuationInfo.text}"
                    link="${discontinuationInfo.link}"
                    link-text="${discontinuationInfo.linkText}"
                ></ux-iws-discontinuation-tooltip>`
        : false;
};

const renderSoftwareStatusLabel = (status: string, label: string) => {
    return `<ux-iws-status-label type=${status}>${label}</ux-iws-status-label>`;
};

export default row;
